/* eslint-disable max-len */
import { useTheme } from '@mui/material';
export const IssueEjectingImage = () => {
  const { palette } = useTheme();

  return (
    <svg
      width="121"
      height="120"
      viewBox="0 0 121 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="120" height="120" transform="translate(0.5)" fill="white" />
      <g clipPath="url(#clip0_3654_15249)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M80 40.9875C80 34.3292 75.8386 31 69.1802 31L-8.18056 31C-14.8389 31 -19.0003 34.3292 -19.0003 40.9875L-19.0003 79.2728C-19.0003 85.9312 -14.8389 89.2603 -8.18056 89.2603L69.1802 89.2603C75.8385 89.2603 80 85.9312 80 79.2728L80 40.9875Z"
          fill={palette.brand.dark}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72 40.9875C72 34.3292 67.8386 31 61.1802 31L-16.1806 31C-22.8389 31 -27.0003 34.3292 -27.0003 40.9875L-27.0003 79.2728C-27.0003 85.9312 -22.8389 89.2603 -16.1806 89.2603L61.1802 89.2603C67.8385 89.2603 72 85.9312 72 79.2728L72 40.9875Z"
          fill={palette.brand.main}
        />
        <mask
          id="mask0_3654_15249"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="20"
          y="36"
          width="44"
          height="44"
        >
          <rect
            x="63.2793"
            y="36"
            width="43.2791"
            height="43.2791"
            transform="rotate(90 63.2793 36)"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_3654_15249)">
          <path
            d="M58.9502 55.5468L41.6916 42.6248L41.6916 52.177L24.3269 42.4922L45.9531 64.1706L45.9531 55.4673L58.9502 65.0194L58.9502 55.5468Z"
            fill="white"
          />
          <path
            d="M52.0188 66.2321L58.9502 71.1416L58.9502 66.1288L52.0302 61.0332L52.0188 66.2321Z"
            fill="white"
          />
          <path
            d="M52.0188 70.5891L58.9502 75.3203L58.9502 72.2212L52.0302 67.3047L52.0188 70.5891Z"
            fill="white"
          />
        </g>
      </g>
      <path
        d="M39 8C40.1046 8 41 8.89543 41 10V31C31.5334 31 23.4765 31 19 31V89H41V110C41 111.105 40.1046 112 39 112H13C11.8954 112 11 111.105 11 110V10C11 8.89543 11.8954 8 13 8H39Z"
        fill={palette.brand.light}
      />
      <path
        d="M32 27C33.1046 27 34 27.8954 34 29V31C27.706 31 22.4118 31 19 31V89H34V91C34 92.1046 33.1046 93 32 93H20C18.8954 93 18 92.1046 18 91V29C18 27.8954 18.8954 27 20 27H32Z"
        fill={palette.brand.darkest}
      />
      <mask
        id="mask1_3654_15249"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="77"
        y="48"
        width="24"
        height="24"
      >
        <rect
          x="101"
          y="48"
          width="24"
          height="24"
          transform="rotate(90 101 48)"
          fill={palette.brand.darkest}
        />
      </mask>
      <g mask="url(#mask1_3654_15249)">
        <path
          d="M82 55.4992L87.4998 55.4992L87.4998 49.9492L99.7998 59.9992L87.4998 70.0492L87.4998 64.4992L82 64.4992L82 55.4992Z"
          fill={palette.brand.darkest}
        />
      </g>
      <mask
        id="mask2_3654_15249"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="62"
        y="4"
        width="49"
        height="48"
      >
        <rect x="62.5" y="4" width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask2_3654_15249)">
        <circle cx="86.5" cy="28" r="18" fill="white" />
        <path
          d="M86.5 30.8L92.3 36.6C92.6667 36.9667 93.1333 37.15 93.7 37.15C94.2667 37.15 94.7333 36.9667 95.1 36.6C95.4667 36.2333 95.65 35.7667 95.65 35.2C95.65 34.6333 95.4667 34.1667 95.1 33.8L89.3 28L95.1 22.2C95.4667 21.8333 95.65 21.3667 95.65 20.8C95.65 20.2333 95.4667 19.7667 95.1 19.4C94.7333 19.0333 94.2667 18.85 93.7 18.85C93.1333 18.85 92.6667 19.0333 92.3 19.4L86.5 25.2L80.7 19.4C80.3333 19.0333 79.8667 18.85 79.3 18.85C78.7333 18.85 78.2667 19.0333 77.9 19.4C77.5333 19.7667 77.35 20.2333 77.35 20.8C77.35 21.3667 77.5333 21.8333 77.9 22.2L83.7 28L77.9 33.8C77.5333 34.1667 77.35 34.6333 77.35 35.2C77.35 35.7667 77.5333 36.2333 77.9 36.6C78.2667 36.9667 78.7333 37.15 79.3 37.15C79.8667 37.15 80.3333 36.9667 80.7 36.6L86.5 30.8ZM86.5 48C83.7333 48 81.1333 47.475 78.7 46.425C76.2667 45.375 74.15 43.95 72.35 42.15C70.55 40.35 69.125 38.2333 68.075 35.8C67.025 33.3667 66.5 30.7667 66.5 28C66.5 25.2333 67.025 22.6333 68.075 20.2C69.125 17.7667 70.55 15.65 72.35 13.85C74.15 12.05 76.2667 10.625 78.7 9.575C81.1333 8.525 83.7333 8 86.5 8C89.2667 8 91.8667 8.525 94.3 9.575C96.7333 10.625 98.85 12.05 100.65 13.85C102.45 15.65 103.875 17.7667 104.925 20.2C105.975 22.6333 106.5 25.2333 106.5 28C106.5 30.7667 105.975 33.3667 104.925 35.8C103.875 38.2333 102.45 40.35 100.65 42.15C98.85 43.95 96.7333 45.375 94.3 46.425C91.8667 47.475 89.2667 48 86.5 48Z"
          fill="#DA1E28"
        />
      </g>
      <defs>
        <clipPath id="clip0_3654_15249">
          <rect
            width="70"
            height="58"
            fill="white"
            transform="translate(18.5 31)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
